module.exports = __webpack_public_path__ + "static/media/13n.049eadf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/13n.svg
// module id = 162
// module chunks = 0